import DocIcon from 'Assets/icons/icon-word.svg';
import XslIcon from 'Assets/icons/icon-excel.svg';
import FileIcon from 'Assets/icons/icon-other.svg';
import PdfIcon from 'Assets/icons/icon-pdf.svg';
import { fileTypeByMime } from 'Constants/commons';
import { shape, string } from 'prop-types';

const FileIconView = ({ file }) => {
  const { mime } = file;
  const fileType = fileTypeByMime(mime);
  switch (fileType) {
    case 'doc':
      return <img src={DocIcon} alt="doc" />;
    case 'pdf':
      return <img src={PdfIcon} alt="pdf" />;
    case 'xsl':
      return <img src={XslIcon} alt="xls" />;
    default:
      return <img src={FileIcon} alt="file" />;
  }
};

FileIconView.propTypes = {
  file: shape({
    mime: string.isRequired,
    thumbPath: string.isRequired,
  }).isRequired,
};

export default FileIconView;
